import { Platform, TextInput, TextInputProps } from "react-native";
import { TextTypes, resolveAHTextStyle } from "../Text/AHText";

import { BoxProps } from "../AHTheme/BoxProps";
import React from "react";
import { useBoxStyle } from "../AHTheme/useBoxStyle";
import { useLayoutContext } from "../LayoutProvider";
import { useScaleFactor } from "../AHScaleFactor";
import { useTheme } from "../AHTheme/AHTheme";

export type AHInputProps = {
  textType?: TextTypes;
  tabIndex?: number;
  defaultStyle?: boolean;
  preventWebClickPropagation?: boolean;
  textInputComponent?: React.ComponentType<TextInputProps>;
  ref?: React.RefObject<TextInput | null>;
} & TextInputProps &
  BoxProps;

/**
 * @deprecated Use <Input> instead.
 */
export const AHInput = ({
  textType = "body-big",
  tabIndex,
  ...props
}: AHInputProps) => {
  const sf = useScaleFactor();
  const boxableStyle = useBoxStyle(props);
  const theme = useTheme();
  const layout = useLayoutContext();

  const webProps =
    Platform.OS === "web"
      ? {
          disabled: props.editable === false ? true : undefined,
          onMouseDown: props.preventWebClickPropagation
            ? (e: any) => {
                e?.stopPropagation?.();
              }
            : undefined,
          onClick: props.preventWebClickPropagation
            ? (e: any) => {
                e?.stopPropagation?.();
              }
            : undefined,
        }
      : {};

  return (
    <TextInput
      {...{ tabIndex }}
      {...webProps}
      ref={props.ref}
      underlineColorAndroid="transparent"
      autoCorrect={false}
      placeholderTextColor={theme.washedText}
      autoCapitalize="none"
      returnKeyType={props.multiline ? "default" : "done"}
      {...props}
      style={[
        boxableStyle,
        resolveAHTextStyle(textType, sf, theme, layout),
        props.defaultStyle
          ? {
              padding: layout.space.medium,
              borderRadius: layout.radius.large,
              backgroundColor: theme["surface-primary"],
              borderWidth: 1,
              borderColor: theme["border-primary"],
            }
          : undefined,
        props.style,
        {
          fontWeight: "normal", // fixes android custom fonts :S
        },
      ]}
    />
  );
};
